import { render, staticRenderFns } from "./AwardsReedemedListSection.vue?vue&type=template&id=fb2f78e2&scoped=true"
import script from "./AwardsReedemedListSection.vue?vue&type=script&lang=js"
export * from "./AwardsReedemedListSection.vue?vue&type=script&lang=js"
import style0 from "./AwardsReedemedListSection.vue?vue&type=style&index=0&id=fb2f78e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb2f78e2",
  null
  
)

export default component.exports